import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import theme from "../../theme/theme";

type Rule = {
    label: string;
    test: (value: string) => boolean;
};

const rules: Rule[] = [
    { label: 'Mind. 8 Zeichen', test: (val) => val.length >= 8 },
    { label: 'Mind. ein Großbuchstabe', test: (val) => /[A-Z]/.test(val) },
    { label: 'Mind. eine Zahl', test: (val) => /\d/.test(val) },
    { label: 'Mind. ein Sonderzeichen', test: (val) => /[^A-Za-z0-9]/.test(val) },
];

interface PasswordRulesCheckerProps {
    value: string;
}

const PasswordRulesChecker: React.FC<PasswordRulesCheckerProps> = ({ value }) => {
    return (
        <Box mt={1}>
            {rules.map((rule, index) => {
                const passed = rule.test(value);
                const Icon = passed ? CheckCircleIcon : CancelIcon;

                return (
                    <Box key={index} display="flex" alignItems="center" gap={1}>
                        <Icon sx={{ color: passed ? theme.palette.success.main : theme.palette.error.main, fontSize: 20 }} />
                        <Typography
                            variant="body2"
                            sx={{ color: passed ? theme.palette.success.main : theme.palette.error.main }}
                        >
                            {rule.label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default PasswordRulesChecker;